import AuditField from "./AuditField";

export default function BlocCoordonnees({ data }) {
  return (
    <section className="space-y-6 bg-white p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-gray-800">Coordonnées</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <AuditField label="Adresse" value={data.adresse} />
        <AuditField label="Code postal" value={data.codePostal} />
        <AuditField label="Ville" value={data.ville} />
        <AuditField label="Pays" value={data.pays} />
        <AuditField label="Email" value={data.email} />
        <AuditField label="Téléphone" value={data.telephone} />
        <AuditField label="Site Web" value={data.siteWeb} />
      </div>
    </section>
  );
}
